import { SNACKBAR_ANCHOR } from "@constants/snackbar";
import {
  Alert,
  AlertColor,
  Snackbar,
  SnackbarCloseReason,
  SnackbarOrigin
} from "@mui/material";
import React from "react";

export interface SnackBarProps {
  id: string;
  open: boolean;
  handleClose: () => void;
  color: AlertColor;
  message: string;
  autoHideDuration?: number;
  anchor?: SnackbarOrigin;
  marginTop?: string;
}
const CustomSnackBar = ({
  id,
  open,
  color,
  message,
  handleClose,
  autoHideDuration,
  marginTop,
  anchor = SNACKBAR_ANCHOR
}: SnackBarProps) => {
  const onAlertDismissed = (
    _?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    handleClose();
  };

  return (
    <Snackbar
      id={id}
      key={id}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onAlertDismissed}
      anchorOrigin={anchor}
      sx={{ marginTop: marginTop }}
    >
      <Alert
        onClose={onAlertDismissed}
        severity={color}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackBar;
